import type { RelaxiRegistrationObligations } from './types';

const storageKey = 'relaxi.registrationLegalState.v2';
export type RegistrationLegalState = {
  obligations?: RelaxiRegistrationObligations;
  accepted?: string[];
  reviewed?: boolean;
};

export const registrationObligationsExpired = ({
  expiresAt,
}: Pick<RelaxiRegistrationObligations, 'expiresAt'>) =>
  !Number.isFinite(Date.parse(expiresAt)) || Date.parse(expiresAt) <= Date.now();

export const getRegistrationLegalState = (): RegistrationLegalState => {
  try {
    const value: unknown = JSON.parse(sessionStorage.getItem(storageKey) ?? 'null');
    if (!isRegistrationState(value)) {
      return {};
    }
    const state = value;
    if (
      !state.obligations ||
      !Array.isArray(state.obligations.requirements) ||
      !Array.isArray(state.accepted) ||
      registrationObligationsExpired(state.obligations)
    ) {
      return {};
    }
    return state;
  } catch {
    return {};
  }
};

export const setRegistrationLegalState = (state: RegistrationLegalState) => {
  sessionStorage.setItem(storageKey, JSON.stringify(state));
};

export const clearRegistrationLegalState = () => {
  sessionStorage.removeItem(storageKey);
};

function isRegistrationState(value: unknown): value is RegistrationLegalState {
  if (
    !value ||
    typeof value !== 'object' ||
    !('obligations' in value) ||
    !value.obligations ||
    typeof value.obligations !== 'object' ||
    !('accepted' in value) ||
    !Array.isArray(value.accepted)
  ) {
    return false;
  }
  const snapshot = value.obligations;
  return (
    'registrationSessionId' in snapshot &&
    typeof snapshot.registrationSessionId === 'string' &&
    'expiresAt' in snapshot &&
    typeof snapshot.expiresAt === 'string' &&
    'requirements' in snapshot &&
    Array.isArray(snapshot.requirements) &&
    value.accepted.every((id: unknown) => typeof id === 'string') &&
    (!('reviewed' in value) || typeof value.reviewed === 'boolean')
  );
}
